import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Button } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import AdminLayout from 'Components/Admin/AdminLayout';
import Loading from 'Components/Loading';
import { loadQRCodes } from 'store/slices/adminSlice';
import QRCodesForm from 'Components/Admin/QRCode/QRCodesForm';
import QRStatTable from 'Components/Admin/QRCode/QRStatTable';

class QRCodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      error: null
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    try {
      this.setState({
        isLoading: true,
        error: null
      });
      console.log('QRCodes: Loading QR codes data...');
      const data = await this.props.loadQRCodes();
      console.log('QRCodes: Received data:', data);
      this.setState({
        data: data || [],
        isLoading: false
      });
    } catch (error) {
      console.error('QRCodes: Error loading data:', error);
      this.setState({
        error: error.message,
        isLoading: false
      });
    }
  };

  render() {
    const {
      data,
      isLoading,
      error
    } = this.state;
    const { t } = this.props;
    return <AdminLayout>
        <Button outline color='primary'><Link to='/admin'><h4>{t("Back")}</h4></Link></Button><p />
        <Helmet>
          <title>{t("QR Codes")}</title>
        </Helmet>
        <Container>
          <h2>{t("QR Codes Management")}</h2>

          <QRCodesForm onSubmit={this.loadData} />

          {error && <div className="alert alert-danger">{t("Error:")}{error}</div>}
          {isLoading ? <Loading /> : <QRStatTable data={data} />}

        </Container>
      </AdminLayout>;
  }

}

const mapDispatchToProps = {
  loadQRCodes
};
export default connect(null, mapDispatchToProps)(withTranslation()(QRCodes));